
const jwt_decode = require("jwt-decode");

const response = {
  statusCode: 500,
  body: JSON.stringify("Not implemented"),
  headers: {    
    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate, max-age=0, s-maxage=0",
    Pragma: "no-cache",
    Expires: "0"
  }
};

const createResetToken = () => {
  return Math.floor(100000 + Math.random() * 900000);
};

const wildcardsEmail = email => {
  if (!email) return 'the registered email address';
  const ar = email.split("@");
  return (
    ar[0].substring(0, 1) + //first
    "****" + //centre
    ar[0].substring(ar[0].length - 1, ar[0].length) + //last
    "@" +
    ar[1]
  ); //domain
};

export async function validateDPIN(event) {
  //const body = event.body;
  console.log("body..." + JSON.stringify(event))
  const body = Object.assign({}, JSON.parse(event.body));
  const token = event.headers["id-token"];
  const decodedToken = jwt_decode(token);
  let tokenval = localStorage.getItem("id_token");


  const validRoles = ["NONGOV.CENTREDIRECTOR", "SCHOOL.PRINCIPAL"];
  var rolesArray = [];
  if (Array.isArray(decodedToken.roles)) {
    rolesArray = [...decodedToken.roles];
  } else {
    rolesArray.push(decodedToken.roles);
  }
  const filteredRole = validRoles.filter(value => rolesArray.includes(value));

  let servicedata = null;
  if (
    event.method === "POST" &&
    body.action === "VERIFY" &&
    (filteredRole.length || decodedToken.acl.some(role => role.match(/TTSDS Director/)))
  ) {
    console.log(" in if 1 " + JSON.stringify(body))
    const directorName = decodedToken.givenName;
    const seNumber = body.seNumber;
    const replyEmail = process.env.REPLY_EMAIL;


    let endpoint = window.config.serverUrl + '/api/service-details/' + seNumber;

    console.log("Searching Service Endpoint > " + endpoint);
    let tokenval = localStorage.getItem("id_token");

    await fetch(endpoint, {
      method: 'GET',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'isportal': true,
        'ssotoken' : tokenval,
        'Content-Type': 'application/json'
      }
    })
      .then(result => result.json())
      .then(data => {
        console.log("in if..." + JSON.stringify(data))
        servicedata = data;
      })
      .catch(err => {
        response.statusCode = 404;
        response.body = JSON.stringify("Your service was not found.");
        return response;

      });

    //Grab the service details based on SE-Number
    /*let centreData = await docClient
      .get({
        Key: {
          seNumber: seNumber
        },
        TableName: CENTRE_TABLE
      })
      .promise();
    if(!centreData.hasOwnProperty('Item')) {
      response.statusCode = 404;
      response.body = JSON.stringify("Your service was not found.");
      //callback(null, response);
    }*/
    const serviceName = servicedata.tradingAsName;
    const email = servicedata.email;
    //Add one hour
    //Get the PIN (random created)


    //check in DB if exists
    let serviceregisterdata = null;
    let endpointregister = `${window.config.serverUrl}/api/service-details-register/${seNumber}/${body.requestedByUserId}`;

    console.log("Searching Service Endpoint for register> " + endpointregister);
     tokenval = localStorage.getItem("id_token");
    await fetch(endpointregister, {
      method: 'GET',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'isportal': true,
        'ssotoken' : tokenval,
        'Content-Type': 'application/json'
      }
    })
      .then(result => result.json())
      .then(async data => {
        console.log("in if..." + JSON.stringify(data))


        serviceregisterdata = data;
        serviceregisterdata.requestedByUserId = body.requestedByUserId
        let pin = "pin";
        console.log("serviceregisterdata"+serviceregisterdata)

        //check if data exists - if not create pin and enter a record
        if (serviceregisterdata == null || serviceregisterdata == undefined || serviceregisterdata === 'undefined' || serviceregisterdata.registerPin == "") {
          console.log("in if.. set the data for pin." + serviceregisterdata)
          serviceregisterdata.serviceId = seNumber;
          // serviceregisterdata.registerPin = "" + pin;
           //Add one hour
          


          //  const expire = (new Date()).getTime() + 1*60*60*1000;

          //  console.log("expire........"+expire)
         
        //  serviceregisterdata.expire=expire;
       //  serviceregisterdata.attempt=1;
          //  serviceregisterdata.createdBy="system";
          //   serviceregisterdata.createdDate=new Date();

          //  let newservicedataobj = JSON.stringify({'serviceId':seNumber,'registerPin':""+pin,'createdBy':'system','createdDate':new Date(),'updatedBy':'system','updatedDate':new Date()});

          //enter a record and add the pin in table 
          console.log("newservicedataobj" + JSON.stringify(serviceregisterdata))
          let dataobj = JSON.stringify(serviceregisterdata)
          let endpointpostregister = window.config.serverUrl + '/api/service-details-register';
          let tokenval = localStorage.getItem("id_token");

          const response1 = fetch(endpointpostregister, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'isportal': true,
              'ssotoken' : tokenval
            },
            body: dataobj
          }).then(result1 => {
              let data1 = result1.json();
              console.log("in endpointpostregister..." + JSON.stringify(data1))

              //send an email mark the status verify

              let emailendpoint = window.config.serverUrl + '/api/service-details-register-email/' + serviceregisterdata.serviceId + '/' + servicedata.email + '/' + decodedToken.givenName + '/' + servicedata.tradingAsName + '/' + body.requestedByUserId
            // let emailendpoint = window.config.serverUrl + '/api/service-details-register-email/' + serviceregisterdata.serviceId + '/' + servicedata.email + '/' + servicedata.nominatedSupervisor + '/' + servicedata.tradingAsName + '/' + body.requestedByUserId 
             fetch(emailendpoint, {
                method: 'GET',
                headers: {
                  'Access-Control-Allow-Origin': '*',
                  'isportal': true,
                  'ssotoken' : tokenval,
                  'Content-Type': 'application/json'
                }
              }).then(result3 => {
                  console.log("email send" + result3)
                  response.statusCode = 200;
                  response.body = JSON.stringify(
                    "A PIN has been sent to:" +
                    wildcardsEmail(email)
                  );
                  return response;
                })





            }

            )




        }
        else {
          //this is for resend the pin
          //pin is already existing 
          // pin = serviceregisterdata.registerPin;

          //reset the expiry date and send the pin with attempt set as 1
          

          //send email with this Pin
          //send an email mark the status verify
          console.log(" decodedToken.givenName"+ decodedToken.givenName)
          let emailendpoint = window.config.serverUrl + '/api/service-details-register-email/' + serviceregisterdata.serviceId + '/' + servicedata.email + '/' + decodedToken.givenName + '/' + body.seNumber + '/' + body.requestedByUserId
          fetch(emailendpoint, {
            method: 'GET',
            headers: {
              'Access-Control-Allow-Origin': '*',
              'isportal': true,
              'ssotoken' : tokenval,
              'Content-Type': 'application/json'
            }
          })
            .then(result3 => {
              console.log("email send for existing pin" + result3)
              response.statusCode = 200;
              response.body = JSON.stringify(
                "A PIN has been sent to:" +
                wildcardsEmail(email)
              );
              return response;
            })
        }


      })
      .catch(err => {

        response.statusCode = 500;
        response.body = JSON.stringify("Internal server error");
        return response;

      });





  } else if (
    event.method === "POST" &&
    body.action === "VERIFIED" &&
    (filteredRole.length || decodedToken.acl.some(role => role.match(/TTSDS Director/)))
  ) {
    console.log(" in if 2" + body.pin)
    const seNumber = body.seNumber;

    const pin = body.pin;
    const expire = body.expire;

    //check PIN is correct - check with register table

    let endpointregister = window.config.serverUrl + '/api/service-details-register/' + seNumber + '/' + body.requestedByUserId;

    console.log("Searching Service Endpoint for register> " + endpointregister);

    await fetch(endpointregister, {
      method: 'GET',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'isportal': true,
        'ssotoken' : tokenval,
        'Content-Type': 'application/json'
      }
    }).then(result => result.json())
      .then(async data => {
        console.log("in else get pin ag" + JSON.stringify(data))
        let jsondata = JSON.stringify(data);

        let now = new Date();
        console.log("now"+now)
        let expiredDBDate = new Date(data.expire);
        console.log("data.expire"+expiredDBDate)
        console.log("data.expire compare"+(now>expiredDBDate))

        if(now>expiredDBDate)
        {
          response.statusCode = 403;
          response.body = JSON.stringify("The PIN entered has expired.");
          return response;

        }

       else if (pin == data.registerPin && parseInt(data.attempt) < 4) {
      //    console.log("in pin compare")
          data.status = 'VERIFIED';
          let endpointpostregister = window.config.serverUrl + '/api/service-details-register';

          const response1 = fetch(endpointpostregister, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'isportal': true,
              'ssotoken' : tokenval
            },
            body: JSON.stringify(data)
          })
            .then(result1 => {
              let data1 = result1.json();
              console.log("in endpointpostregister posted data as verifed result1" + JSON.stringify(data1))

            })
          console.log("Add Director");
          // Use the person's detuserid
          const detuserid = decodedToken.detuserguid;
          console.log(detuserid);

          let schema = [
            {
              "op": "add",
              "path": "entitlements",
              "value": {}
            }
          ];
          schema[0].value = { [seNumber]: "Director" };
          console.log("schema..." + JSON.stringify(schema));

          const url = window.config.serverUrl + '/api/service-details-register/idm/patchservice/' + decodedToken.detuserguid;

          fetch(url, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'isportal': true,
              'ssotoken' : tokenval
            },
            body: JSON.stringify(schema)
          })
            .then(resultS => {
              console.log("results", JSON.stringify(resultS));
              // response.body = JSON.stringify({ message: resultS });
              response.statusCode = 200;
              //   return response;
            })

          response.body = JSON.stringify("The PIN you entered was correct.");
          response.statusCode = 200;
          return response;



        } else if(parseInt(data.attempt) >= 4)
        {
          response.body = JSON.stringify("Failed number of attempts is more than Four");
          response.statusCode = 403;
          return response;
        }else {
          /*var attempt = row.Item.attempt + 1;
        await docClient
          .put({
            TableName: DIRECTOR_TABLE,
            Item: {
              seNumber: seNumber,
              email: row.Item.email,
              name: row.Item.name,
              service: row.Item.service,
              pin: pin,
              attempt: attempt,
              status: "VERIFY",
              expire: row.Item.expire
            }
          })
          .promise();*/

          response.body = JSON.stringify("The PIN you entered was not correct.");
          response.statusCode = 403;

          data.status = 'VERIFY';
          data.attempt = data.attempt + 1;
          let endpointpostregister = window.config.serverUrl + '/api/service-details-register';
          const response2 = await fetch(endpointpostregister, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'isportal': true,
              'ssotoken' : tokenval
            },
            body: JSON.stringify(data)
          })
            .then(result1 => {
              result1.json();

            }).then(data1 => {

              console.log("in endpointpostregister posted data as verifed..." + JSON.stringify(data1))
              response.statusCode = 403;
              response.body = JSON.stringify("The PIN you entered was not correct.");
              return response;
            })





        }
      })



  }


  return response;



}


async function fetchText(url, options) {
  console.log("fetchText");
  const response = await fetch(url, options);
  console.log("response", response);
  const results = await response.text();
  console.log("RESULTS", results);
  return results;
}

async function formatDate(timestamp) {
  const date = new Date(timestamp);
  const day = date.toLocaleString("en-AU", {
    timeZone: "Australia/Sydney",
    day: "2-digit"
  });
  const month = date.toLocaleString("en-AU", {
    timeZone: "Australia/Sydney",
    month: "2-digit"
  });
  const year = date.toLocaleString("en-AU", {
    timeZone: "Australia/Sydney",
    year: "numeric"
  });
  return {
    timestamp: timestamp,
    date: date.toLocaleString("en-AU", { timeZone: "Australia/Sydney" }),
    day: day,
    month: month,
    year: year,
    full: `${day}/${month}/${year}`,
    scim: `${year}${month}${day}`,
    monthYear: `${month}/${year}`
  };
}
